import { useState } from "react";
import { useStore } from "../store/Store";
import Footer from "../components/Footer";

function InvoiceModal({ order, onClose }) {
  return (
    <div onClick={onClose} style={{ position:"fixed", inset:0, background:"rgba(26,26,46,0.5)", zIndex:9999, display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} className="invoice-modal-overlay">
      <style>{`
        @media print {
          body * { visibility: hidden; }
          .invoice-print-area, .invoice-print-area * { visibility: visible; }
          .invoice-print-area { position: absolute; left: 0; top: 0; width: 100%; padding: 24px; }
          .invoice-modal-overlay { position: static !important; background: none !important; }
          .invoice-no-print { display: none !important; }
        }
      `}</style>
      <div onClick={e=>e.stopPropagation()} style={{ background:"white", borderRadius:16, maxWidth:480, width:"100%", maxHeight:"90vh", overflowY:"auto", padding:28 }} className="invoice-print-area">
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:20 }}>
          <div>
            <div style={{ fontFamily:"'Noto Serif Devanagari',serif", fontSize:20, fontWeight:900, color:"#EC4899" }}>मॅचवेल</div>
            <div style={{ fontSize:10, color:"#999" }}>Gulmandi Corner, Chh. Sambhajinagar, Maharashtra</div>
          </div>
          <button onClick={onClose} className="invoice-no-print" style={{ background:"none", border:"none", fontSize:18, cursor:"pointer", color:"#999" }}>✕</button>
        </div>

        <h3 style={{ fontFamily:"'Playfair Display',serif", fontSize:18, fontWeight:800, color:"#1a1a2e", marginBottom:4 }}>Invoice</h3>
        <div style={{ fontSize:12, color:"#999", marginBottom:18 }}>Order {order.id} · {order.date}</div>

        <div style={{ background:"#fafafa", borderRadius:10, padding:14, marginBottom:16, fontSize:12 }}>
          <div style={{ fontWeight:700, marginBottom:2 }}>{order.addr?.name}</div>
          <div style={{ color:"#666" }}>{order.addr?.phone}</div>
          <div style={{ color:"#666" }}>{order.addr?.address}, {order.addr?.city} - {order.addr?.pincode}</div>
        </div>

        <table style={{ width:"100%", borderCollapse:"collapse", fontSize:12, marginBottom:16 }}>
          <thead>
            <tr style={{ borderBottom:"2px solid #1a1a2e" }}>
              <th style={{ textAlign:"left", padding:"6px 4px" }}>Item</th>
              <th style={{ textAlign:"center", padding:"6px 4px" }}>Qty</th>
              <th style={{ textAlign:"right", padding:"6px 4px" }}>Amount</th>
            </tr>
          </thead>
          <tbody>
            {order.items?.map((it,i)=>(
              <tr key={i} style={{ borderBottom:"1px solid #f0f0f0" }}>
                <td style={{ padding:"6px 4px" }}>{it.name} {it.sc?`(${it.sc}, ${it.ss})`:""}</td>
                <td style={{ textAlign:"center", padding:"6px 4px" }}>{it.qty}</td>
                <td style={{ textAlign:"right", padding:"6px 4px" }}>₹{(it.price*it.qty).toLocaleString("en-IN")}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {order.discount > 0 && (
          <div style={{ display:"flex", justifyContent:"space-between", fontSize:12, color:"#16A34A", marginBottom:6 }}>
            <span>Coupon ({order.couponCode})</span><span>-₹{order.discount.toLocaleString("en-IN")}</span>
          </div>
        )}
        <div style={{ display:"flex", justifyContent:"space-between", fontSize:15, fontWeight:900, color:"#1a1a2e", borderTop:"2px solid #1a1a2e", paddingTop:8, marginBottom:20 }}>
          <span>Total Paid</span><span>₹{order.total?.toLocaleString("en-IN")}</span>
        </div>

        <div style={{ fontSize:11, color:"#999", marginBottom:20 }}>Payment method: {order.pay?.toUpperCase()}</div>

        <button onClick={()=>window.print()} className="invoice-no-print" style={{ width:"100%", padding:12, background:"#1a1a2e", color:"white", border:"none", borderRadius:50, fontSize:13, fontWeight:700, cursor:"pointer" }}>
          🖨️ Print / Save as PDF
        </button>
      </div>
    </div>
  );
}

export default function OrdersPage({ onNav }) {
  const { orders, cancelOrder, adminWhatsApp } = useStore();
  const [invoiceOrder, setInvoiceOrder] = useState(null);

  return (
    <div className="page-top-pad" style={{ background:"white", minHeight:"100vh" }}>
      <div style={{ background:"linear-gradient(135deg,#1a1a2e,#2d1b69)", padding:"24px clamp(16px,4vw,40px)" }}>
        <h1 style={{ fontFamily:"'Playfair Display',serif", fontSize:"clamp(20px,4vw,32px)", fontWeight:900, color:"white" }}>My Orders 📦</h1>
      </div>
      <div style={{ padding:"24px clamp(14px,4vw,40px)", maxWidth:760 }}>
        {orders.length===0 ? (
          <div style={{ textAlign:"center", padding:"80px 0" }}>
            <div style={{ fontSize:56, marginBottom:16 }}>📦</div>
            <h3 style={{ fontFamily:"'Playfair Display',serif", fontSize:24, fontWeight:900, color:"#1a1a2e", marginBottom:12 }}>No Orders Yet</h3>
            <button onClick={()=>onNav("shop")} style={{ background:"#EC4899", color:"white", border:"none", padding:"13px 32px", borderRadius:50, fontSize:14, fontWeight:700, cursor:"pointer" }}>Start Shopping</button>
          </div>
        ) : orders.map(o=>(
          <div key={o.id} style={{ background:"white", border:"1px solid #f0f0f0", borderRadius:16, padding:20, marginBottom:14, boxShadow:"0 2px 16px rgba(0,0,0,0.05)" }}>
            <div style={{ display:"flex", justifyContent:"space-between", flexWrap:"wrap", gap:10, marginBottom:14 }}>
              <div>
                <div style={{ fontFamily:"'Playfair Display',serif", fontSize:16, fontWeight:700, color:"#1a1a2e" }}>{o.id}</div>
                <div style={{ fontSize:11, color:"#999" }}>{o.date} · {o.items?.length} item(s)</div>
              </div>
              <div style={{ textAlign:"right" }}>
                <div style={{ fontWeight:900, fontSize:18, color:"#1a1a2e" }}>₹{o.total?.toLocaleString("en-IN")}</div>
                <span style={{ fontSize:10, fontWeight:700, background:o.status==="Cancelled"?"#FEF2F2":"#F0FDF4", color:o.status==="Cancelled"?"#EF4444":"#16A34A", padding:"3px 10px", borderRadius:20 }}>{o.status}</span>
              </div>
            </div>

            {o.status!=="Cancelled" && (
              <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:0, marginBottom:12 }}>
                {["Confirmed","Packed","Shipped","Delivered"].map((st,i)=>{
                  const statuses = ["Confirmed","Packed","Shipped","Delivered"];
                  const curIdx = statuses.indexOf(o.status);
                  const active = i <= curIdx;
                  return (
                    <div key={st} style={{ textAlign:"center" }}>
                      <div style={{ height:4, background:active?"#10B981":"#f0f0f0", marginBottom:5, borderRadius:2 }}/>
                      <div style={{ fontSize:8, letterSpacing:1, textTransform:"uppercase", color:active?"#10B981":"#ccc", fontWeight:active?700:400 }}>{st}</div>
                    </div>
                  );
                })}
              </div>
            )}
            {o.status!=="Cancelled" && <div style={{ fontSize:12, color:"#999", marginBottom:10 }}>Expected: <strong style={{ color:"#1a1a2e" }}>{o.eta}</strong></div>}

            <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
              <a href={`https://wa.me/${adminWhatsApp}?text=${encodeURIComponent(`Hi! Track my order ${o.id}`)}`} target="_blank" rel="noreferrer"
                style={{ fontSize:11, fontWeight:700, color:"#16A34A", background:"#F0FDF4", border:"1px solid #86EFAC", padding:"7px 16px", borderRadius:50, textDecoration:"none" }}>
                💬 Track
              </a>
              <a href={`https://wa.me/${adminWhatsApp}?text=${encodeURIComponent(`Return/Exchange request\nOrder: ${o.id}\nReason: `)}`} target="_blank" rel="noreferrer"
                style={{ fontSize:11, fontWeight:700, color:"#EF4444", background:"#FEF2F2", border:"1px solid #FECACA", padding:"7px 16px", borderRadius:50, textDecoration:"none" }}>
                ↩️ Return
              </a>
              <button onClick={()=>setInvoiceOrder(o)}
                style={{ fontSize:11, fontWeight:700, color:"#1a1a2e", background:"#fafafa", border:"1px solid #e5e5e5", padding:"7px 16px", borderRadius:50, cursor:"pointer" }}>
                🧾 Invoice
              </button>
              {o.status==="Confirmed" && (
                <button onClick={()=>{ if(window.confirm(`Cancel order ${o.id}?`)) cancelOrder(o.id); }}
                  style={{ fontSize:11, fontWeight:700, color:"#EF4444", background:"white", border:"1px solid #FECACA", padding:"7px 16px", borderRadius:50, cursor:"pointer" }}>
                  ✕ Cancel Order
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
      {invoiceOrder && <InvoiceModal order={invoiceOrder} onClose={()=>setInvoiceOrder(null)}/>}
      <Footer onNav={onNav}/>
    </div>
  );
}
